import { Button } from 'antd';
import React from 'react';

import './styles.css';


const CustomAntButton: React.FC<any> = ({ type = 'primary', className = '', ...props }) => {
    return <Button {...props} className={`button ${className} ${type}`} />;
};

export default CustomAntButton;
